<template>
  <th
    scope="col"
    class="cursor-pointer px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
  >
    <div class="flex flex-row">
      {{ title }}
      <IconSelector />
    </div>
  </th>
</template>
<script>
import IconSelector from "@/assets/icons/IconSelector";

export default {
  name: "ColumnHeader",
  components: {
    IconSelector
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>
